export const resetFormValues = (values) => ({
  ubication: {
    currentStepUbication: values?.ubication?.currentStepUbication,
    ubicationType: {
      id: values?.ubication?.ubicationType?.id,
      nombre: values?.ubication?.ubicationType?.nombre,
      value: values?.ubication?.ubicationType?.value,
      label: values?.ubication?.ubicationType?.label
    },
    uunn: {
      id: values?.ubication?.uunn?.id,
      nombre: values?.ubication?.uunn?.nombre,
      value: values?.ubication?.uunn?.value,
      label: values?.ubication?.uunn?.label
    },
    ubication: {
      id: values?.ubication?.ubication?.id,
      nombre: values?.ubication?.ubication?.nombre,
      value: values?.ubication?.ubication?.value,
      label: values?.ubication?.ubication?.label
    },
    event: {
      id: values?.ubication?.event?.id,
      nombre: values?.ubication?.event?.nombre,
      sigla: values?.ubication?.event?.sigla,
      eventoPozoId: values?.ubication?.event?.eventoPozoId,
      value: values?.ubication?.event?.value,
      label: values?.ubication?.event?.label
    },
    team: {
      value: values?.ubication?.team?.value,
      label: values?.ubication?.team?.label
    }
  },
  imputationObject: {
    wells: values.imputationObject.wells
  },
  service: {
    probDate: values?.service?.probDate,
    needDate: values?.service?.needDate
  },
  approver: {
    currentStepApprover: null,
    approvers: []
  }
});

export const menuActions = {
  salir: 'Salir',
  finalizar: 'Finalizar Servicio',
  reprogramar: 'Reprogramar',
  cancelar: 'Cancelar solicitud',
  rechazar: 'Rechazar',
  aceptarSolicitud: 'Aceptar Solicitud',
  cancelarAceptacion: 'Cancelar Aceptacion'
};

export const hasWorkReportMessage = 'Parte de trabajo existente';
export const errorNotSupervisor = 'Agregar supervisor';

export const workReportLineStatus = {
  1: 'Pendiente',
  2: 'Enviada',
  3: 'Aprobada',
  4: 'Devuelta',
  5: 'Fijada'
};

export const OWSincronizationStatus = {
  check: 1,
  sincronizacion: 2,
  devolver: 3
};

// export const OWSincronizationStatusMessage = {
//   1: 'Sincronizado',
//   2: 'Sincro',
//   2: 3
// }

export const attachmentFileColorIcon = {
  disabled: 1,
  enabled: 2,
  hasAttachmentFile: 3,
  requiredAttachmentFile: 4
};

export const certificationServiceStatus = {
  sendReturned: 0,
  noSend: 1,
  send: 2,
  reject: 3,
  wrong: 4,
  approve: 5
};

export const initialValuesASDS = {
  isOyM: false,
  ubication: {
    ubicationType: null,
    uunn: null,
    installation: null,
    ubication: '',
    event: null,
    team: null
  },
  imputationObject: {
    wells: []
  },
  service: {
    service: null,
    probDate: '',
    needDate: '',
    description: ''
  },
  provider: {
    moreBusinessUnits: false,
    providers: [
      {
        businessUnit: null,
        provider: null,
        contract: null,
        notificate: null
      }
    ]
  }
};

export const notifyEnum = {
  withOutNotification: 1,
  supervisor: 2,
  provider: 3
};

export const oYMEventValues = {
  eventId: 31,
  eventName: 'Evento OyM',
  eventAbreviation: 'OyM'
};
export const businessTypeEnum = {
  towerServices: 1,
  OYM: 2
};
// Cuando realizamos una plantilla a partir de un borrador
// una plantilla a partir de una solicitud
// o una solicitud a partir de una solicitud (replicar)
// debemos indicarle al back de que a que vamos
// para que ellos puedan buscar y copiar los archivos correspondientes
export const copyFilesOriginDestinyEnum = {
  BorradorAPlantilla: 0,
  PlantillaASolicitud: 1,
  SolicitudASolicitud: 2
};

/** 10 MB expressed in KB */
export const MAX_FILE_SIZE = 10_485_760;

export const MAX_DOWNLOAD_SIZE = 100000; // 10 MB
